import Cookies from 'universal-cookie';

/**
 * Keeps ID cookies as strings for every universal-cookie read in the app (PRJCBUGEN-65884).
 *
 * universal-cookie runs JSON.parse on every value, so a Mongo ID made only of digits and one `e`
 * is read as a number: '647751016117557730e75149' becomes Infinity and was sent to APIs as the
 * header `accountid: Infinity`. Instead of changing every `cookies.get(...)` call, this patches
 * Cookies.prototype.get once: for the ID cookies below, a value that parses to a number is
 * returned as the raw string. All other cookies and all normal (hex) IDs are unchanged.
 *
 * Imported first in src/index.jsx (and in src/setupTests.js for Jest). Safe to import more than once.
 */
export const ID_COOKIE_NAMES = ['accountId', 'userAccountId', '_Id', 'userid', 'userId'];

const PATCHED = Symbol.for('insight.cookieIdGuard');

if (!Cookies.prototype[PATCHED]) {
  const originalGet = Cookies.prototype.get;
  Cookies.prototype.get = function get(name, options = {}) {
    const value = originalGet.call(this, name, options);
    if (typeof value === 'number' && ID_COOKIE_NAMES.includes(name)) {
      return originalGet.call(this, name, { ...options, doNotParse: true, doNotUpdate: true });
    }
    return value;
  };
  Cookies.prototype[PATCHED] = true;
}
